"use strict";
var Observable_1 = require('../../Observable');
var race_1 = require('../../observable/race');
Observable_1.Observable.race = race_1.race;
//# sourceMappingURL=race.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/~/rxjs/add/observable/race.js
// module id = ../../../../rxjs/add/observable/race.js
// module chunks = 4